module.exports = __webpack_public_path__ + "files/4e7e3885175ceb0dc431ef19cf9a99a6.svg";